import { ExclusionRule } from '@/API';
import { GenericService } from '@/service/GenericService';
import { ExclusionRuleRepository } from '@/repository/ExclusionRuleRepository';
import {
  onCreateExclusionRule,
  onDeleteExclusionRule,
  onUpdateExclusionRule,
} from '@/graphql/subscriptions';

/**
 * Service for managing ExclusionRule records
 */
export class ExclusionRuleService extends GenericService<ExclusionRule> {
  constructor(repository: ExclusionRuleRepository) {
    super(repository);
  }

  async onCreateEvent<T>(execute: (data: T) => void) {
    return await this.onEvent(execute, onCreateExclusionRule);
  }

  async onDeleteEvent<T>(execute: (data: T) => void) {
    return await this.onEvent(execute, onDeleteExclusionRule);
  }

  async onUpdateEvent<T>(execute: (data: T) => void) {
    return await this.onEvent(execute, onUpdateExclusionRule);
  }

  // public list(options?: GraphQLOptionsV6['variables']) {
  //   return this.repository.list(options);
  // }
}
